"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeChallengeResults = void 0;
const ObserverList_1 = require("./ObserverList");
function makeChallengeResults() {
    return new ChallengeResultsImp();
}
exports.makeChallengeResults = makeChallengeResults;
class ChallengeResultsImp {
    constructor() {
        this.observers = new ObserverList_1.ObserverList();
        this.resultLookup = new Map();
        this.submitHitResult = (slideID, success, tries, message) => {
            const resultData = {
                success,
            };
            const result = {
                slideID,
                message,
                resultData,
                tries,
                type: 'HIT',
            };
            this.resultLookup.set(slideID, result);
            this.observers.notify();
        };
        this.submitMultiHitResult = (slideID, hits, misses, unanswered, tries, message) => {
            const resultData = {
                hits,
                misses,
                unanswered,
            };
            const result = {
                slideID,
                message,
                resultData,
                tries,
                type: 'MULTIHIT',
            };
            this.resultLookup.set(slideID, result);
            this.observers.notify();
        };
        this.submitQualityResult = (slideID, stars, maxStars, tries, message) => {
            const resultData = {
                stars,
                maxStars,
            };
            const result = {
                slideID,
                message,
                resultData,
                tries,
                type: 'QUALITY',
            };
            this.resultLookup.set(slideID, result);
            this.observers.notify();
        };
        this.submitScoreResult = (slideID, score, maxScore, tries, message) => {
            const resultData = {
                score,
                maxScore,
            };
            const result = {
                slideID,
                message,
                resultData,
                tries,
                type: 'SCORE',
            };
            this.resultLookup.set(slideID, result);
            this.observers.notify();
        };
        this.getResultForSlide = (slideID) => {
            return this.resultLookup.get(slideID);
        };
        this.submitProgressResult = (slideID, maxProgress, message) => {
            const currentResult = this.getResultForSlide(slideID);
            if (currentResult && currentResult.resultData.maxProgress > maxProgress) {
                return;
            }
            const resultData = {
                maxProgress,
            };
            const result = {
                slideID,
                message,
                resultData,
                tries: 1,
                type: 'PROGRESS',
            };
            this.resultLookup.set(slideID, result);
            this.observers.notify();
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
    }
    get results() {
        return Array.from(this.resultLookup.values());
    }
}
